module.exports = __webpack_public_path__ + "static/media/7.ffea51b8.jpg";